__turbopack_context__.v({
  "ad-article-halfbanner": "--HIVG_ad-article-halfbanner",
  "ad-article-lleaderboard": "--HIVG_ad-article-lleaderboard",
  "button-article": "--HIVG_button-article",
  "detail": "--HIVG_detail",
  "header-article": "--HIVG_header-article",
  "section": "--HIVG_section",
  "subTitle": "--HIVG_subTitle",
  "title": "--HIVG_title",
  "wrapper": "--HIVG_wrapper",
});
